import React, { Component } from 'react';
import { connect } from "@common/components/base.component";
import Form from '@common/components/validation/form.validation';
import autoBind from 'react-autobind';
import { ddados } from "../responderExigencia.ddados";
import DDadosItem from '@common/components/ddados/ddados.item';
import { Row, Col, Modal } from 'react-bootstrap';
import responderExigenciaSelector from "../store/responderExigencia.selectors";
import responderExigenciaActions from "../store/responderExigencia.actions";
import Button from "@material-ui/core/Button";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onClose() {
    this.props.responderExigenciaActions.toggleExigenciaModal();
  }

  render() {
    const { Campos } = ddados;
    const { responderExigenciaSelector } = this.props;
    const { responderExigencia } = responderExigenciaSelector;
    const { ModalExigencia, ShowModalExigencia } = responderExigencia;

    return (
      <Modal show={ShowModalExigencia} onHide={this.onClose} size="lg">
        <Form className="box-form-cadastro">
          {form => (
            <div>
              <Modal.Header>
                <Modal.Title>
                  <h3>Visualização de Documento, Exigência e Motivo</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col>
                    <DDadosItem name="TipoDocumento" {...Campos.TipoDocumento} state={ModalExigencia} isView={true} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DDadosItem name="Exigencia" {...Campos.Exigencia} state={ModalExigencia} isView={true} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DDadosItem name="Motivo" {...Campos.Motivo} state={ModalExigencia} isView={true} />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outlined" color="primary" onClick={this.onClose}>
                  <i className="fa fa-times" />&nbsp;Fechar
                </Button>
              </Modal.Footer>
            </div>
          )}
        </Form>
      </Modal>
    );
  }
}

export default connect({
  actions: {
    responderExigenciaActions
  },
  selectors: {
    responderExigenciaSelector
  }
})(Container);
